import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { styled } from '@mui/material'
import { Help } from '@mui/icons-material'
import { TableCell as BaseTableCell, Tooltip as BaseTooltip } from '@chilecompra/react-kit/components'

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-bottom: 10px;
  padding-top: 16px;
  width: 100%;
`

export const FlexRow = styled('div')`
  align-items: ${({ align }) => align || 'stretch'};
  display: flex;
  grid-gap: ${({ gap }) => gap || '10px'};
  grid-template-columns: ${({ columns }) => columns || 'repeat(auto-fit, minmax(100px, 1fr))'};
  justify-content: ${({ justify }) => justify || 'start'};
  width: 100%;
`

export const InfoIcon = styled(Help)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.black2};
    height: 20px;
    width: 20px;
  }
`

export const Link = styled(({ bold, children, disabled, secondary, textDecoration, ...props }) => (
  <a {...props}>{children}</a>
))`
  align-items: center;
  color: ${props => (props.secondary || props.disabled ? props.theme.palette.gray[50] : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${props => (props.bold ? 'bold' : '400')};
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: ${props => (props.textDecoration ? 'underline' : 'none')};

  &:hover {
    color: ${props => (props.secondary ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
    text-decoration: underline;
  }
`

export const LinkInternal = styled(RouterLink)`
  align-items: center;
  color: ${props => (props.secondary || props.disabled ? props.theme.palette.gray[50] : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 14px;
  font-weight: ${props => (props.bold ? 'bold' : '400')};
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: ${props => (props.textDecoration ? 'underline' : 'none')};

  &:hover {
    color: ${props => (props.secondary ? props.theme.palette.gray[35] : props.theme.palette.blue[35])};
    text-decoration: underline;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const Strong = styled('strong')`
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'} !important;

    &:first-child {
      padding: ${props => props.padding || '12px 9px 16px 0'} !important;
    }

    &:last-child {
      border-right: 0;
      padding: ${props => props.padding || '12px 0 16px 9px'} !important;
    }
  }
`

export const Tooltip = styled(BaseTooltip)`
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    max-height: 100px;
    max-width: 338px;

    & > div {
      max-height: 100%;
    }
  }
`

export const TooltipContainer = styled('div')`
  align-items: center;
  padding-bottom: 10px;
`

export const TooltipIcon = styled('span')`
  align-items: center;
  display: flex;
  float: left;
`
